import ApplicationState from "../ApplicationState";
import Pagination from "./Pagination";

export default class RemotePagination extends Pagination
{
    private pageNumber: number;
    private xhr: typeof ApplicationState.axios;
    private isLoadingNow: boolean = false;
    private perPage: number;
    private itemsCount: number;
    private catalogUrl: string;    

    /**
     * @param perPage    - кол-во элементов на страницу
     * @param itemsCount - кол-во элементов (например кол-во товаров)
     */
    public constructor(perPage: number, itemsCount: number)
    {
        super();

        this.pageNumber = this.getPageNumber(window.location.pathname);
        this.xhr = ApplicationState.axios;
        this.perPage = perPage;
        this.itemsCount = itemsCount;
    }

    public isPageLast(): boolean
    {
        return this.pageNumber >= Math.ceil(this.itemsCount / this.perPage);
    }

    public getNextPageNumber(): number
    {
        return this.pageNumber + 1;
    }

    public setCatalogUrl(url: string)
    {
        this.catalogUrl = url;
    }

    public loadNext(): Promise<any>
    {
        if (this.isLoadingNow) {
            return;
        }

        this.isLoadingNow = true;

        return new Promise((resolve, reject) => {
            this.xhr.post(
                this.catalogUrl,
                this.getFormDataForNextPage(this.getNextPageNumber()),
                {timeout: 10000} // запросы по каталогу могут тупить
            ).then(rsp => {
                this.pageNumber = this.getNextPageNumber();
                
                resolve(rsp);
            })
            .catch(err => reject(err))
            .then(() => {
                this.isLoadingNow = false;
            });
        });
    }

    public loadPaginationHtml(url: string): Promise<any>
    {
        let formData = new FormData;

        formData.append('baseUrl', this.deletePageNumberFromUrl(window.location.pathname));
        formData.append('page', this.pageNumber.toString());
        formData.append('total', this.itemsCount.toString());
        formData.append('perPage', this.perPage.toString());
        formData.append('queryString', this.getQueryString());

        return this.xhr.post(url, formData);
    }

    private getFormDataForNextPage(nextPageNumber: number): FormData
    {
        let data = new FormData;

        data.append('type', 'ajaxPagination');
        data.append('pageNumber', nextPageNumber.toString());
        data.append('queryString', this.getQueryString());

        return data;
    }

    private getQueryString(): string
    {
        return window.location.search.replace(/^\?/, '');
    }
}
